import { Alert, AlertColor, Backdrop, CircularProgress, Grid, Typography } from '@mui/material';
import moment from 'moment';
import BackNavigationButton from '../../../components/common/BackNavigationButton';
import PageContainer from '../../../components/common/PageContainter';
import StyledCard from '../../../components/common/StyledCard';
import StyledCardTitleBar from '../../../components/common/StyledCardTitleBar';
import HousekeepingCurrentLists from '../../../components/services/housekeeping/HousekeepingCurrentLists';
import useSubscriber from '../../../hooks/useSubscriber';
import { getServiceStatusColor, getServiceStatusName } from '../../../utils/common';

const HousekeepingOverview = () => {
    const { data: subscriber, isFetching: subscriberLoading, refetch: subscriberRefetch } = useSubscriber();

    const handleRefetch = () => {
        subscriberRefetch();
    };

    return (
        <PageContainer>
            {subscriber && '_id' in subscriber && subscriber._id && (
                <>
                    <Typography variant="h5" sx={{ marginBottom: 2 }}>
                        <BackNavigationButton {...(subscriber && { url: `/subscribers/${subscriber._id}` })} /> Housekeeping Overview for{' '}
                        {subscriber.username}
                    </Typography>

                    <StyledCard noCard noBottomMargin>
                        <StyledCardTitleBar title="Housekeeping" />
                    </StyledCard>

                    <StyledCard>
                        <Grid container flexGrow={1} spacing={1} alignItems="start">
                            <Grid item xs>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item xs={12}>
                                        Paid Date:{' '}
                                        {subscriber.housekeeping && subscriber.housekeeping.paidDate
                                            ? moment(subscriber.housekeeping.paidDate).format('L')
                                            : 'Payment not found'}
                                    </Grid>
                                    <Grid item xs={12}>
                                        Paid Until:{' '}
                                        {subscriber.housekeeping && subscriber.housekeeping.paidDate
                                            ? moment(subscriber.housekeeping.paidDate).add(1, 'month').format('L')
                                            : 'Payment not found'}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={'auto'}>
                                <Alert severity={getServiceStatusColor(subscriber, 'housekeeping', false) as AlertColor}>
                                    {getServiceStatusName(subscriber, 'housekeeping', false)}
                                </Alert>
                            </Grid>
                        </Grid>
                    </StyledCard>

                    <HousekeepingCurrentLists subscriber={subscriber} handleSubscriberRefetch={handleRefetch} />
                </>
            )}
            <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={subscriberLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </PageContainer>
    );
};

export default HousekeepingOverview;
